var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect-field',_vm._g(_vm._b({attrs:{"options":_vm.genres}},'multiselect-field',_vm.$props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }